import React, { useState, useEffect, useRef } from 'react';

import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Dropdown } from 'react-bootstrap';
import show from '../../../../assets/images/show.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faPaperclip, faPaperPlane, faXmark } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { SAVERECOVERY } from '../../../../Utils/conts.js';
import { toast } from 'react-toastify';
import Select from 'react-select';

const Charges = ({ allData, onChildAction }) => {
  const currencyOptions = [
    { value: "EUR", label: "EUR (€) - Euro", symbol: '€' },
    { value: "USD", label: "USD ($) - US Dollar", symbol: '$' },
    { value: "PHP", label: "PHP (₱) - Philippine Peso", symbol: '₱' },
    { value: "JPY", label: "JPY (¥) - Japanese Yen", symbol: '¥' },
    { value: "GBP", label: "GBP (£) - British Pound", symbol: '£' },
    { value: "AUD", label: "AUD (A$) - Australian Dollar", symbol: 'A$' },
    { value: "CHF", label: "CHF (Fr.) - Swiss Franc", symbol: 'Fr.' },
    { value: "CAD", label: "CAD (C$) - Canadian Dollar", symbol: 'C$' },
    { value: "MXN", label: "MXN ($) - Mexican Peso", symbol: '$' },
    { value: "CNY", label: "CNY (¥) - Chinese Yuan", symbol: '¥' },
    { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar", symbol: 'NZ$' },
    { value: "SEK", label: "SEK (kr) - Swedish Krona", symbol: 'kr' },
    { value: "RUB", label: "RUB (₽) - Russian Ruble", symbol: '₽' },
    { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar", symbol: 'HK$' },
    { value: "NOK", label: "NOK (kr) - Norwegian Krone", symbol: 'kr ' },
    { value: "SGD", label: "SGD (S$) - Singapore Dollar", symbol: 'S$' },
    { value: "TRY", label: "TRY (₺) - Turkish Lira", symbol: '₺' },
    { value: "KRW", label: "KRW (₩) - South Korean Won", symbol: '₩' },
    { value: "ZAR", label: "ZAR (R) - South African Rand", symbol: 'R' },
    { value: "BRL", label: "BRL (R$) - Brazilian Real", symbol: 'R$' },
    { value: "INR", label: "INR (₹) - Indian Rupee", symbol: '₹' },
    { value: "SAR", label: "SAR (﷼) - Saudi Riyal", symbol: '﷼' },
    { value: "DKK", label: "DKK (kr) - Danish Krone", symbol: 'kr' },
    { value: "RON", label: "RON (lei) - Romanian Leu", symbol: 'lei' },
    { value: "XAF", label: "XAF (Fr) - Central African CFA Franc", symbol: 'Fr' },
    { value: "XOF", label: "XOF (Fr) - West African CFA Franc", symbol: 'Fr' },
    { value: "DOP", label: "DOP (RD$) - Dominican Peso", symbol: 'RD$)' },
    { value: "HTG", label: "HTG (G) - Haitian Gourde", symbol: 'G' },
    { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar", symbol: 'Bds$' },
    { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar", symbol: 'TT$)' },
    { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar", symbol: 'EC$' },
    { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder", symbol: 'ƒ' },
    { value: "COP", label: "COP (COL$) - Colombian Peso", symbol: 'COL$' },
    { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights", symbol: 'SDR' },
    { value: "XBT", label: "XBT (₿) - Bitcoin", symbol: '₿' },
    { value: "WGH", label: "WGH - West German Hard Currency", symbol: 'WGH' },
  ];
  const isMounted = useRef(false);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [formData, setFormData] = useState({});
  const [isEditable, setIsEditable] = useState(false);

  const fetchSettings = async () => {
    try {
      const res = await withRFSToken.get('general-setting/get-setting');
      const innerData = res?.data?.response_data?.settings;
      const currencySet = innerData.currency ? currencyOptions.find(opt => opt.value == innerData.currency) : 'EUR';
      console.log("innerData", currencySet)

      setSelectedCurrency(currencySet)
      setFormData(prev => ({
        ...prev,
        // incidental_ch_curr: currencySet.value,
        // warehouse_ch_curr: currencySet.value,
        // destruction_ch_curr: currencySet.value,
        // transport_ch_curr: currencySet.value,

        // pre_collection_curr: currencySet.value,
        // collection_risk_curr: currencySet.value,

        // collection_amount_curr: currencySet.value,
        // import_duties_curr: currencySet.value,
        // value_added_tax_curr: currencySet.value,
        // penalty_curr: currencySet.value,
        // other_ch_curr: currencySet.value,
        // final_payment_curr: currencySet.value,
        // recharge_amount_curr: currencySet.value,
      }))
    } catch (error) {
      console.error('Error fetching settings:', error);
      // toast.error('Failed to load settings');
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    fetchSettings()
    isMounted.current = true;
  }, []);
  useEffect(() => {
    if (allData) {
      setFormData(prev => ({
        ...prev,
        ...allData?.charges
      }))
    }
  }, [allData]);

  const warehouse = [
    { label: 'Incidental Charges :', name: 'incidental_ch', type: 'number', curr: selectedCurrency?.label, currName: 'incidental_ch_curr' },
    { label: 'Warehouse Charges :', name: 'warehouse_ch', type: 'number', curr: selectedCurrency?.label, currName: 'warehouse_ch_curr' },
    { label: 'Destruction Charges :', name: 'destruction_ch', type: 'number', curr: selectedCurrency?.label, currName: 'destruction_ch_curr' },
    { label: 'Transport Charges :', name: 'transport_ch', type: 'number', curr: selectedCurrency?.label, currName: 'transport_ch_curr' }
  ];
  const collection = [
    { label: 'Non clearance ref :', name: 'non_clearance_ref', type: 'text', dateName: 'non_clearance_ref_date' },
    { label: 'Pre collection ref :', name: 'pre_collection_ref', type: 'text', dateName: 'pre_collection_ref_date' },
    { label: 'Collection ref :', name: 'collection_ref', type: 'text', dateName: 'collection_ref_date' },
    { label: 'Payment ref :', name: 'payment_ref', type: 'text', dateName: 'payment_ref_date' },

    { label: 'Pre collection :', name: 'pre_collection', type: 'number', curr: selectedCurrency?.label, currName: 'pre_collection_curr' },
    { label: 'Collection risk :', name: 'collection_risk', type: 'number', curr: selectedCurrency?.label, currName: 'collection_risk_curr' },

    { label: 'Collection amount :', name: 'collection_amount', type: 'number', curr: selectedCurrency?.label, currName: 'collection_amount_curr' },
    { label: 'Import duties :', name: 'import_duties', type: 'number', curr: selectedCurrency?.label, currName: 'import_duties_curr' },
    { label: 'Value added tax :', name: 'value_added_tax', type: 'number', curr: selectedCurrency?.label, currName: 'value_added_tax_curr' },
    { label: 'Penalty :', name: 'penalty', type: 'number', curr: selectedCurrency?.label, currName: 'penalty_curr' },
    { label: 'Other charges :', name: 'other_ch', type: 'number', curr: selectedCurrency?.label, currName: 'other_ch_curr' },
    { label: 'Final payment :', name: 'final_payment', type: 'number', curr: selectedCurrency?.label, currName: 'final_payment_curr' },
    { label: 'Final payment date :', dateName: 'final_payment_date', type: 'date', },
    { label: 'Recharge amount :', name: 'recharge_amount', type: 'number', curr: selectedCurrency?.label, currName: 'recharge_amount_curr' },
  ];

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value })
  }

  const handleToggleEdit = () => {
    if (isEditable) {
      handleFinish();
      setIsEditable(false)
    } else {
      setIsEditable(true)
    }
  };

  const handleFinish = async () => {

    const getOrigin = allData.stations.find(i => i.handler_type == 'Origin');
    const getDest = allData.stations.find(i => i.handler_type == 'Destination');
    const transformedData = {
      ...allData,
      origin_notify_status: allData.origin_notify_status == true ? 1 : 0,
      destination_notify_status: allData.origin_notify_status == true ? 1 : 0,
      all_stations: [
        {
          handler_feedback_id: getOrigin.handler_feedback_id,
          station_name: allData.origin,
          type: 'Origin',
          handler_id: allData.origin_handler_id,
          notify_status: allData.origin_notify_status == true ? 1 : 0
        },
        {
          handler_feedback_id: getDest.handler_feedback_id,
          station_name: allData.destination,
          type: 'Destination',
          handler_id: allData.destination_handler_id,
          notify_status: allData.destination_notify_status == true ? 1 : 0
        },
        ...allData.all_stations
      ],
      charges: formData
      // files: [
      //     ...(formData.files || []),
      //     ...filterPrimary.map((file) => ({ id: file.id, primary: file.primary })),
      //     ...restFiles.map((file) => ({ id: file.id, primary: 0 })),
      // ]
    };
    try {
      const res = await withRFSToken.post(SAVERECOVERY, transformedData)
        .then(function (res) {
          // setIsLoading(false);
          if (res.data.response_code == 200) {
            toast.success(res.data.response_msg);
            // setTimeout(() => {
            // window.location.href = '/ServiceRecovery';
            // }, 1000);
            setIsEditable(false)
            // setTabChange(false);
            onChildAction();
          } else {
            toast.error(res.data.response_msg);
          }
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }


  return (
    <>
      {console.log('selectedCurrency', selectedCurrency)}
      <Row>
        <Col sm={6}>
          <div className='flbg mb-3'>
            <div className='overview_head'>
              <h5 className='d-flex align-items-center justify-content-between'>
                Hadlities & warehouse
                {allData?.isEditable &&
                  <button onClick={handleToggleEdit} className='serv_edit_save ms-2' >
                    <FontAwesomeIcon icon={faPencilAlt} className='pe-1' /> {isEditable ? "SAVE" : "EDIT"}
                  </button>
                }
              </h5>
              {/* <p>Flight details and ground handlers details.</p> */}
            </div>
            <div className='fld-sl fld-sl-ch'>
              <div className='tsk-lst d-flex justify-content-between align-items-center mb-1'>
                {/* <h4>Charges Overview</h4> */}
              </div>
              {warehouse.map(opt => (
                <Row className='mb-2'>
                  <Col lg="4"><Form.Label>{opt.label} {opt?.re == 1 ? <><span>*</span></> : ''}</Form.Label></Col>
                  <Col lg="5"><Form.Control type={opt.type} name={opt.name} placeholder="" value={formData[opt.name] || ''} onChange={handleFormChange} disabled={!isEditable} /></Col>
                  {/* <Col lg="3"><Form.Control type='text' placeholder="" value={opt.curr} readOnly /></Col> */}
                  <Col lg="3">
                    <Select
                      options={currencyOptions}
                      onChange={(selected) => {
                        const updatedData = { ...formData, [opt.currName]: selected.value };
                        setFormData(updatedData);
                      }}
                      placeholder="Select"
                      // className='autoslct'
                      name={opt.currName}
                      value={formData[opt.currName] ?
                        currencyOptions.find(curr => curr.value === formData[opt.currName])
                        : currencyOptions.find(curr => curr.value === selectedCurrency?.value)}
                      isDisabled={!isEditable}
                    />
                  </Col>
                </Row>
              ))}
            </div>
          </div>
          <div className='flbg'>
            <div className='overview_head'>
              <h5>Collection and Reterence information</h5>
              {/* <p>Flight details and ground handlers details.</p> */}
            </div>
            <div className='fld-sl fld-sl-ch'>
              <div className='tsk-lst d-flex justify-content-between align-items-center mb-1'>
                {/* <h4>Charges Overview</h4> */}
              </div>
              {collection.map((opt, index) => (
                <>
                  <Row className='mb-2'>
                    <Col lg="4"><Form.Label>{opt.label} {opt?.re == 1 ? <><span>*</span></> : ''}</Form.Label></Col>
                    <Col lg={opt.dateName && opt.name ? "4" : '5'}>
                      <Form.Control type={opt.type} name={opt.name ? opt.name : opt.dateName} placeholder="" value={formData[opt.name] ? formData[opt.name] : formData[opt.dateName] || ''} onChange={handleFormChange} disabled={!isEditable} />
                    </Col>
                    {(opt.dateName && opt.name) && <Col lg="1"><Form.Label>Date:</Form.Label></Col>}
                    <Col lg="3">
                      {(opt.dateName && opt.name || opt.curr) &&
                        <>
                          {opt.curr ?
                            <>
                              <Select
                                options={currencyOptions}
                                onChange={(selected) => {
                                  const updatedData = { ...formData, [opt.currName]: selected.value };
                                  setFormData(updatedData);
                                }}
                                placeholder="Select"
                                // className='autoslct'
                                name={opt.currName}
                                value={formData[opt.currName] ?
                                  currencyOptions.find(curr => curr.value === formData[opt.currName])
                                  : currencyOptions.find(curr => curr.value === selectedCurrency?.value)}
                                isDisabled={!isEditable}
                              />
                              {/* {console.log('opt.name', opt.name)} */}
                            </>
                            :
                            <Form.Control
                              type={opt.dateName ? 'date' : opt.type}
                              name={opt.dateName ? opt.dateName : ''}
                              placeholder=""
                              value={opt.dateName ? formData[opt.dateName] : opt.curr || ''}
                              onChange={opt.dateName ? handleFormChange : ''}
                              readOnly={!opt.dateName && !!opt.name}
                              disabled={opt.dateName && !isEditable}
                            />
                          }

                        </>
                      }
                    </Col>
                  </Row>
                  {(index == 3 || index == 5) && <><hr /></>}
                </>
              ))}

            </div>
          </div>
        </Col>
        <Col sm={6}>
          <div className='flbg h-100'>
            <div className='overview_head'>
              <h5>Legal Procedure</h5>
              {/* <p>Flight details and ground handlers details.</p> */}
            </div>
            <div className='fld-sl fld-sl-ch'>
              <div className='tsk-lst d-flex justify-content-between align-items-center mb-1'>
                {/* <h4>Charges Overview</h4> */}
              </div>
              <Row className='mb-2'>
                <Col lg="4">
                  <Form.Label>Legal Procedure :</Form.Label>
                </Col>
                <Col lg="8">
                  {/* Inline Radio Buttons */}
                  <Form className='ch-rdo'>
                    <div>
                      {['N/A', 'Cleared', 'Appeal', 'Refund'].map((type, index) => (
                        <>
                          <Form.Check
                            inline
                            label={type}
                            name="legal_Procedure"
                            type='radio'
                            id={`inline-${type}-${index + 1}`}
                            value={type}
                            checked={formData.legal_Procedure === type}
                            onChange={handleFormChange}
                            disabled={!isEditable}
                          />
                        </>
                      ))}
                    </div>
                  </Form>
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col lg="4">
                  <Form.Label>Legal stage :</Form.Label>
                </Col>
                <Col lg="8">
                  {/* Inline Radio Buttons */}
                  <Form className='ch-rdo'>
                    <div>
                      {['N/A', 'Cleared', 'Appeal'].map((type, index) => (
                        <Form.Check
                          inline
                          label={type}
                          name="legal_stage"
                          type='radio'
                          id={`inline-${type}-${index + 1}`}
                          value={type}
                          checked={formData.legal_stage === type}
                          onChange={handleFormChange}
                          disabled={!isEditable}
                        />
                      ))}
                    </div>
                  </Form>
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col lg="4">
                  <Form.Label>Appeal Ref :</Form.Label>
                </Col>
                <Col lg="8">
                  <Form.Control type="text" name='appeal_ref' placeholder="" value={formData.appeal_ref} onChange={handleFormChange} disabled={!isEditable} />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Charges